import { Button, Grid, SvgIcon, TextField } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import BlockIcon from "@material-ui/icons/Block";
import CallIcon from "@material-ui/icons/Call";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EmailIcon from "@material-ui/icons/Email";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import SmsIcon from "@material-ui/icons/Sms";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../images/discountRequest.svg";
import http from "../services/httpService";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import InputLabel from "@material-ui/core/InputLabel";
import {
  activityLogPath,
  addDiscountPath,
  notesReview,
  communicatioTimeLinePath,
  createEmailPath,
  createNotificationPath,
  editProspectPath,
  emailMask,
  getDate,
  investmentProfilePath,
  maskMobile,
  personalProfilePath,
  prospectGoalsDashboardPath,
  prospectPath,
  prospectSatisfactionPath,
  referralDashboardPath,
  addPaymentPath,
  landingpage2Path,
  addSubscriptionPath,
  reassignRmList,
  addpaymentlinks,
} from "../utils/varialbles";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  tile: {
    height: "80px",
    backgroundColor: "#FFF",
    textAlign: "center",
    width: "80%",
    cursor: "pointer",
    color: "#393939",
    padding: "5%",
    border: "#67729429",
    "&:hover": {
      backgroundColor: "#3f51b5",
      color: "#F5F7FA",
    },
  },
  analyticwindow: {
    backgroundColor: "#F5F7FA",
    color: "#393939",
    width: "300px",
  },
  button: {
    marginRight: "5px",
    borderRadius: "10px",
  },
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function ProspectDetails() {
  let history = useHistory();
  const [callBtnDisable, setCallBtnDisable] = useState(false);
  const classes = useStyles();
  const [Prospect_Basic_info, setProspect_Basic_info] = useState({});
  const [Prospect_Assigned_info, setProspect_Assigned_info] = useState({});
  const [Prospect_questionnaire, setProspect_questionnaire] = useState({});
  const [Prospect_details, setProspect_details] = useState([]);
  const [call_Analytics, setcall_Analytics] = useState({});
  const [openArchivingModal, setOpenArchivingModal] = useState(false);
  const [showWindow, setShowWindow] = useState(false);
  const [formObject, setFormObject] = useState({
    archiveComment: "",
  });
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [disableUpdateBtn, setDisableUpdateBtn] = useState(false);
  const [noteval, setNoteval] = useState("");
  const [currentUser, setCurrentUser] = useState(null);
  const [friendly, setFriendly] = useState(null);
  const [block, setBlock] = useState(null);
  const [email, setEmail] = useState(null);
  const myparam = location.state;
  let archivingButtonsDisabled =
    location.state.cust__custregmobile.includes("Archiving");
  const handleClose = () => {
    setOpen(false);
    setOpenArchivingModal(!openArchivingModal);
  };
  const callCustomer = (e) => {
    e.preventDefault();

    if (myparam && myparam.cust__id) {
      setCallBtnDisable(true);
      http
        .get("/callrequest?cust_id=" + myparam.cust__id + "&location=P")
        .then((res) => {
          if (res && res.data && res.data.Data && res.data.statusCode === 0) {
            toast.success(
              "Call Request Placed successfully,Please wait for the call..!"
            );
          } else {
            toast.error("Call Request Failed");
          }
        })
        .catch((err) => {
          toast.error("Call Request Failed");
        });
    }
  };
  const blockUser = (e) => {
    if (myparam && myparam.cust__custfirstname) {
      setOpen(true);
      setCurrentUser(myparam.cust__custfirstname);
    } else {
      toast.error("Prospect name not Available..!");
      setCurrentUser(null);
    }
  };
  const gotoGoalsDashBoard = (e) => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectGoalsDashboardPath,
        state: myparam,
      });
    }
  };

  const CHARACTER_LIMIT = 2000;
  let archiveCommentLimit = 255;

  const handleChange = (e) => {
    setNoteval(e.target.value);
  };

  const handleChangeArchiveComment = (event) => {
    setFormObject({
      ...formObject,
      archiveComment: event.target.value,
    });
  };
  const note = { note: noteval };

  const handleUpdate = (e) => {
    http
      .post("/saveNote/" + myparam.cust__id + "/", note)
      .then((response) => {
        if (response.data.statusCode === 0) {
          toast.success(response.data.data);
          setNoteval("");
        }

        // setFromObject(form)
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  const submitBlock = (e) => {
    if (myparam && myparam.cust__id) {
      http
        .patch("/blockuser?id=" + myparam.cust__id)
        .then((res) => {
          setOpen(false);
          if (res && res.data && res.data.Data) {
            toast.success(res.data.Data);
            handleCancel();
          } else {
            toast.error("Unable to block prospect..!");
          }
        })
        .catch((err) => {
          toast.error("Unable to block prospect..!");
        });
    }
  };
  const setFriendlyBtn = (e) => {
    if (myparam && myparam.cust__id) {
      http
        .patch("/friendly?id=" + myparam.cust__id)
        .then((res) => {
          if (res && res.data && res.data.Data) {
            toast.success(res.data.Data);
            handleCancel();
          } else {
            toast.error("Unable to Set Friendly..!");
          }
        })
        .catch((err) => {
          toast.error("Unable to Set Friendly..!");
        });
    }
  };
  const getCommunication = (e) => {
    e.preventDefault();

    if (myparam && myparam.cust__id) {
      setCallBtnDisable(false);
      history.push({
        pathname: communicatioTimeLinePath,
        state: myparam,
      });
    }
  };
  const gotoActivityLog = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: activityLogPath,
        state: myparam,
      });
    }
  };
  const editProspect = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: editProspectPath,
        state: myparam,
      });
    }
  };
  const gotoInvestmentProfile = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: investmentProfilePath,
        state: myparam,
      });
    }
  };
  const gotoReferalDashboard = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: referralDashboardPath,
        state: myparam,
      });
    }
  };
  const gotoPersonalProfile = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: personalProfilePath,
        state: myparam,
      });
    }
  };
  const gotoAddpayment = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: addPaymentPath,
        state: myparam,
      });
    }
  };
  const gotoAddSubscription = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: addSubscriptionPath,
        state: myparam,
      });
    }
  };
  const gotoRequestDiscount = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: addDiscountPath,
        state: myparam,
      });
    }
  };
  const gotoProspectSatisfaction = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectSatisfactionPath,
        state: myparam,
      });
    }
  };
  const sendNotifiCation = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: createNotificationPath,
        state: myparam,
      });
    }
  };
  // goto RM-reassign page
  const gotoRmReassignPage = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: reassignRmList,
        state: myparam,
      });
    }
  };
  const sendEmail = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: createEmailPath,
        state: myparam,
      });
    }
  };
  const gotoLandingpage2 = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: landingpage2Path,
        state: myparam,
      });
    }
  };
  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    {
      lable: "How did you get to know about Savart?",
      filedType: "dropDown",
      value: "enquiry",
    },
    {
      lable: "Communication Preference",
      filedType: "dropDown",
      value: "communication",
    },
    {
      lable: "Was he/ She interested in the services?",
      filedType: "dropDown",
      value: "interest",
    },
    {
      lable: "If not interested, what was the reason for disinterest?",
      filedType: "text",
      value: "reason_notinterest",
    },
    {
      lable: "Was he/ She polite with communication",
      filedType: "dropDown",
      value: "politeness",
    },
    {
      lable: "Family background",
      filedType: "text",
      value: "family_background",
    },
    { lable: "Goal Details", filedType: "text", value: "goal" },
    {
      lable: "Have you ever invested before?",
      filedType: "dropDown",
      value: "previous_investment",
    },
    {
      lable: "If yes, How was your experience?",
      filedType: "text",
      value: "inv_exp",
    },
    {
      lable: "If yes, with which broker? what was the quantum?",
      filedType: "text",
      value: "broker_quantum",
    },
    {
      lable: "If yes, with which adivisor? what was the quantum?",
      filedType: "text",
      value: "advisor_quantum",
    },
    // { "lable": "Prospect Location", "filedType": "dropDown" ,"value":"loc_country"},
  ];

  const [tagData, setTagData] = useState([]);
  const [currentTagData, setCurrentTagData] = useState([]);

  const [showPMsOPtions, setShowPMSOptions] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedRadioTags, setSelectedRadioTags] = useState([]);

  useEffect(() => {
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
    handleCancel();

    http
      .get(`customertags/${myparam.cust__id}/`)
      .then((res) => {
        setTagData(res.data.data.all_tags);
        setCurrentTagData(res.data.data.current_tags);
      })
      .catch((err) => {
        console.log(err);
      });
    const inputs = document.querySelectorAll("input");

    inputs.forEach((input) => {
      currentTagData.forEach((item) => {
        if (item.name === input.id) {
          input.checked = true;
        }
      });
    });
  }, [showPMsOPtions]);

  const sendOtp = () => {
    if (myparam && myparam.cust__id) {
      let cust_id = myparam.cust__id;
      const baseUrl = "/sendOTP";
      http
        .get(`${baseUrl}?cust_id=${cust_id}`)
        .then((res) => {
          const statusCode = res.data.statusCode;
          if (statusCode === 0) {
            // (res.data.Data);
            toast.success(res.data.Data);
          }
        })
        .catch((err) => {
          // (err)
        });
    }
  };

  const handleCancel = () => {
    toast.dismiss();
    // (myparam);
    //toast.loading("Please wait..");
    if (myparam && myparam.cust__id) {
      let cust_id = myparam.cust__id;
      http
        .get("/prospect_detail_view/" + cust_id)
        .then((res) => {
          // (res);
          toast.dismiss();
          setProspect_details(res.data);
          setEmail(res.data.Email);
          setBlock(res.data.Block);
          if (res.data.note !== null) {
            // setNoteval(res.data.note);
          }
          if (
            res &&
            res.data &&
            res.data.Prospect_Basic_info &&
            res.data.Prospect_Basic_info.length > 0
          ) {
            setProspect_Basic_info(res.data.Prospect_Basic_info[0]);
            if (
              res.data.Prospect_Assigned_info &&
              res.data.Prospect_Assigned_info.length > 0
            ) {
              setProspect_Assigned_info(res.data.Prospect_Assigned_info[0]);
            }
            if (
              res.data.Prospect_questionnaire &&
              res.data.Prospect_questionnaire.length > 0
            ) {
              setProspect_questionnaire(res.data.Prospect_questionnaire[0]);
            }
            if (res.data.call_Analytics && res.data.call_Analytics.length > 0) {
              setcall_Analytics(res.data.call_Analytics[0]);
            }

            if (res.data && res.data.friendly) {
              setFriendly(true);
            } else if (res.data && res.data.friendly == false) {
              setFriendly(false);
            } else if (res.data && res.data.friendly == null) {
              setFriendly(null);
            }

            setShowWindow(true);
          } else {
            history.push(prospectPath);
          }
        })
        .catch((err) => {
          toast.dismiss();
        });
    } else {
      history.push(prospectPath);
    }
  };

  const goBack = (e) => {
    e.preventDefault();
    history.push({
      state: Object,
      pathname: prospectPath,
    });
  };

  const gobackpage = (e) => {
    e.preventDefault();
    history.push({
      state: {
        page: myparam.page,
      },
      pathname: prospectPath,
    });
  };

  const gotoNotesReviewPage = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: notesReview,
        state: myparam,
      });
    }
  };

  const gotoaddPaymentLinksPage = () => {
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: addpaymentlinks,
        state: myparam,
      });
    }
  };

  const ArchivingModalOpen = () => {
    setOpenArchivingModal(!openArchivingModal);
  };
  const submitArchiveProspect = (e) => {
    let finalObject = {
      id: myparam.cust__id,
      comment: formObject.archiveComment,
    };
    if (formObject.archiveComment !== "") {
      http
        .post("/prospect_archive", finalObject)
        .then((response) => {
          if (response.data.statusCode === 0) {
            toast.success(response.data.data);
          }
          setFormObject(formObject);
          setOpenArchivingModal(!openArchivingModal);
        })
        .catch((error) => {
          toast.error(error);
        });
    } else {
      toast.error("Enter Comments");
    }
  };

  const handlePmsTag = (e, itemName) => {
    if (e.target.checked) {
      setSelectedTags((prevSelectedTags) => [...prevSelectedTags, itemName]);
    } else {
      // Remove the tag from the selectedTags array if unchecked
      setSelectedTags((prevSelectedTags) =>
        prevSelectedTags.filter((tag) => tag !== itemName)
      );
    }
  };

  const handlePmsRadioTag = (e, itemName) => {
    const input = document.getElementById(itemName);

    if (itemName === "PMS" && input.checked) {
      document.getElementById("PIA").checked = false;
      setSelectedRadioTags([e.target.value]);
    }
    if (itemName === "PIA" && input.checked) {
      document.getElementById("PMS").checked = false;
      setSelectedRadioTags([e.target.value]);
    }

    if (itemName === "PMS" && !input.checked) {setSelectedRadioTags([]);}

    if(itemName === "PIA" && !input.checked){setSelectedRadioTags([]);}    
  };

  console.log(selectedRadioTags, "selectedTags");
  console.log(currentTagData, "currentTagData");

  const toggleSelect = () => {
    setShowPMSOptions((val) => !val);
    const tagNames = currentTagData.map((tag) => tag.name);

    tagNames.forEach((item) => {
      if (item === "PMS" || item === "PIA") {
        setSelectedRadioTags([item]);
      } else {
        setSelectedTags((prevTags) => [...prevTags, item]);
      }
    });
  };

  const saveSelectedTags = () => {
    let postObj={};
    if(selectedRadioTags.length === 0 && selectedRadioTags === 0){
       postObj = {
        selected_tags: "Untagged",
      };
    }
    else{
       postObj = {
        selected_tags: [...selectedTags, ...selectedRadioTags].join(","),
      };
    }
    
    http
      .post(`customertags/${myparam.cust__id}/`, postObj)
      .then((res) => {
        toast.success(res.data.data);
        setShowPMSOptions(false);
        handleCancel();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <Grid
        container
        style={showWindow ? { display: "block" } : { display: "none" }}
      >
        {/* <Paper className={classes.root,"paper"}>className="pb30"
                <Grid container className={'overviewbar'}>
                    <Grid item xs={12} sm={5} md={6} lg={8} xl={9} >
                        <Button name="Overview" variant="contained" color="primary" onClick={e=>history.goBack()}>Overview</Button>
                    </Grid>
                    <Grid item xs={12} sm={5} md={4} lg={3} xl={2} >
                        <Button name="Overview" variant="contained" color="primary" style={{  borderRadius: "10px" }} onClick={gotoAddpayment}>Add Payment                            
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={5} md={4} lg={3} xl={2} >
                        <Button name="Overview" variant="contained" color="primary" style={{  borderRadius: "10px" }} onClick={gotoRequestDiscount}>Request Discount
                            <span style={{ paddingLeft: "15px" }}>
                                <SvgIcon >
                                    <Logo />
                                </SvgIcon>
                            </span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}  lg={1} xl={1} >
                        <Button variant="contained" color={Prospect_Basic_info.blocked?"primary":'secondary'} startIcon={<BlockIcon variant="outlined" />} style={{ borderRadius: "10px" }} onClick={blockUser} 
                        >{Prospect_Basic_info.blocked?"UnBlock":"Block"}</Button>
                    </Grid>
                </Grid>
            </Paper>
            <Grid container style={{ marginTop: "10px" }}>
                <Grid item xs={12} sm={2} md={2} lg={3} xl={7} className={'overviewbar'}>
                    <Typography  variant="h6">
                        {myparam ? (myparam.cust__custfirstname + " " + myparam.cust__custlastname) : ""}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={10} lg={9} xl={5} align="right" className={'overviewbar'}>
                    <Button variant="contained" color="primary" className={classes.button} onClick={getCommunication}>Communication Timeline</Button>
                    <Button variant="contained" color="primary" className={classes.button} disabled={callBtnDisable} onClick={callCustomer} endIcon={<CallIcon variant="outlined" />}>Call</Button>
                    <Button variant="contained" color="primary" className={classes.button} onClick={sendEmail} endIcon={<EmailIcon variant="outlined" />}>Email</Button>
                    <Button variant="contained" color="primary" className={classes.button} endIcon={<SmsIcon variant="outlined" />} disabled>Sms</Button>
                    <Button variant="contained" color="primary" className={classes.button} endIcon={<NotificationsActiveIcon variant="outlined" />} onClick={sendNotifiCation}>Notify</Button>
                </Grid>

            </Grid> */}

        <div className="menuhead">
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            style={{ height: "40px", marginLeft: 5, marginRight: 15 }}
            onClick={gobackpage}
          >
            Back
          </Button>
          <button className="ovrbtn" onClick={goBack}>
            Overview
          </button>
        </div>

        <div className="menuheadchild">
          <div
            style={{ fontSize: "24px", color: "#393939", fontWeight: "bold" }}
          >
            {myparam ? (
              <>
                {myparam.cust__custfirstname
                  ? myparam.cust__custfirstname
                  : "Unnamed"}
                {myparam.cust__custlastname
                  ? " " + myparam.cust__custlastname
                  : " Customer"}{" "}
                {myparam.cust__userID ? myparam.cust__userID : "N/A"}
              </>
            ) : (
              ""
            )}{" "}
          </div>
          {archivingButtonsDisabled !== true ? (
            <>
              <div className="menuchildbtns">
                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO") && (
                  <>
                    <Button
                      className="button"
                      onClick={ArchivingModalOpen}
                      // disabled={archivingButtonsDisabled}
                    >
                      Archive
                    </Button>
                  </>
                )}
                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager" ||
                  localStorage.getItem("empRole") === "BTL Manager") && (
                  <>
                    <Button
                      className="button"
                      onClick={gotoAddSubscription}
                      // disabled={archivingButtonsDisabled}
                    >
                      Add Subscription
                    </Button>
                  </>
                )}
                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") ===
                    "Customer Delight Executive" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") ===
                    "Sales and Retention Specialist" ||
                  localStorage.getItem("empRole") === "Sales Manager") && (
                  <Button
                    className="button"
                    onClick={sendOtp}
                    // disabled={archivingButtonsDisabled}
                  >
                    Send OTP
                  </Button>
                )}
                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager" ||
                  localStorage.getItem("empRole") ===
                    "Business Growth Executive" ||
                  localStorage.getItem("empRole") === "BTL Executive" ||
                  localStorage.getItem("empRole") === "BTL Manager" ||
                  localStorage.getItem("empRole") === "MF Manager" ||
                  localStorage.getItem("empRole") === "Franchise" ||
                  localStorage.getItem("empRole") ===
                    "Sales and Retention Specialist" ||
                  localStorage.getItem("empRole") === "MF Executive") && (
                  <>
                    <Button
                      className="button"
                      onClick={gotoAddpayment}
                      // disabled={archivingButtonsDisabled}
                    >
                      Create Payment Link
                    </Button>
                  </>
                )}

                {/* {localStorage.getItem("empRole") === "MF Manager" ||
              localStorage.getItem("empRole") === "MF Executive" ||
              localStorage.getItem("empRole") === "Franchise" ? (
              ""
            ) : (
              <button className="button" onClick={gotoRequestDiscount}>
                <span>Request Discount </span>
                <span style={{ paddingLeft: "9px", display: "flex" }}>
                  <SvgIcon>
                    <Logo />
                  </SvgIcon>
                </span>
              </button>
            )} */}
                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager" ||
                  localStorage.getItem("empRole") ===
                    "Business Growth Executive" ||
                  localStorage.getItem("empRole") === "BTL Executive" ||
                  localStorage.getItem("empRole") ===
                    "Sales and Retention Specialist" ||
                  localStorage.getItem("empRole") === "BTL Manager") && (
                  // localStorage.getItem("empRole") === "MF Manager" ||
                  // localStorage.getItem("empRole") === "Franchise"
                  <>
                    <Button
                      className="button"
                      onClick={gotoRequestDiscount}
                      // disabled={archivingButtonsDisabled}
                    >
                      <span>Request Discount </span>
                      <span style={{ paddingLeft: "9px", display: "flex" }}>
                        <SvgIcon>
                          <Logo />
                        </SvgIcon>
                      </span>
                    </Button>
                  </>
                )}

                <Button
                  className="button"
                  onClick={callCustomer}
                  // disabled={archivingButtonsDisabled}
                >
                  <span>Call</span>{" "}
                  <span style={{ paddingLeft: "9px", display: "flex" }}>
                    {" "}
                    <CallIcon />{" "}
                  </span>
                </Button>
                {email ? (
                  <Button
                    className="button"
                    onClick={sendEmail}
                    // disabled={archivingButtonsDisabled}
                  >
                    <span>Email</span>{" "}
                    <span style={{ paddingLeft: "9px", display: "flex" }}>
                      {" "}
                      <EmailIcon />{" "}
                    </span>
                  </Button>
                ) : null}
                {(localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager") && (
                  <>
                    <Button
                      className="button"
                      onClick={sendNotifiCation}
                      // disabled={archivingButtonsDisabled}
                    >
                      <span>Notify</span>{" "}
                      <span style={{ paddingLeft: "9px", display: "flex" }}>
                        {" "}
                        <NotificationsActiveIcon />{" "}
                      </span>
                    </Button>
                  </>
                )}
                {localStorage.getItem("empRole") === "Sales Manager" && (
                  <>
                    {block ? (
                      <Button
                        variant="contained"
                        // disabled={archivingButtonsDisabled}
                        color={
                          Prospect_Basic_info.blocked ? "primary" : "secondary"
                        }
                        startIcon={<BlockIcon variant="outlined" />}
                        style={{ borderRadius: "10px", marginBottom: "10px" }}
                        onClick={blockUser}
                      >
                        {Prospect_Basic_info.blocked ? "UnBlock" : "Block"}
                      </Button>
                    ) : null}
                  </>
                )}
              </div>
            </>
          ) : (
            ""
          )}
        </div>

        {/* <Grid container style={{ marginTop: "20px" }}>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Typography  variant="caption">Mobile Number</Typography>
                    <Typography  variant="h6">{Prospect_Basic_info.custcountrycode + " " + Prospect_Basic_info.custregmobile}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Typography  variant="caption">Email ID</Typography>
                    <Typography  variant="h6">{Prospect_Basic_info.custemail}</Typography>

                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Typography  variant="caption">Signed Up Date</Typography>
                    <Typography  variant="h6">{getDate(Prospect_Basic_info.createddt)}</Typography>

                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Typography  variant="caption">Last Login</Typography>
                    <Typography  variant="h6">{getDate(Prospect_Basic_info.last_login)}</Typography>

                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Typography  variant="caption">{"Assigned Executive     "} <EditOutlinedIcon style={{cursor:"pointer"}} onClick={editProspect}></EditOutlinedIcon></Typography>
                    <Typography  variant="h6">{Prospect_Assigned_info.assigned_executive}  </Typography>
                   
                </Grid>
            </Grid> */}

        <div className="prospectdetails">
          <div className="prospectdetailsrow1">
            <div>
              <Typography variant="caption">Mobile Number</Typography>
              <Typography variant="h6">
                {"+" +
                  Prospect_Basic_info.custcountrycode +
                  " " +
                  Prospect_Basic_info.custregmobile}
              </Typography>
            </div>

            <div>
              <Typography variant="caption">Signed Up Date</Typography>
              <Typography variant="h6">
                {getDate(Prospect_Basic_info.createddt)}
              </Typography>
            </div>

            <div>
              <Typography variant="caption">Status</Typography>
              <Typography variant="h6">
                {Prospect_Assigned_info.status}
              </Typography>
            </div>

            {/* <div>
                        <Typography  variant="caption">Get Back Date</Typography>
                        <Typography  variant="h6">{getDate(Prospect_Assigned_info.get_back_date)}</Typography>
                    </div> */}
          </div>

          <div className="prospectdetailsrow1">
            <div>
              {/* <Typography  variant="caption">{"Assigned Executive"} <EditOutlinedIcon style={{cursor:"pointer"}} onClick={editProspect}></EditOutlinedIcon></Typography> */}
              <Typography variant="caption">{"Assigned Executive"}</Typography>
              <Typography variant="h6">
                {Prospect_Assigned_info.assigned_executive}
              </Typography>
            </div>
            <div>
              <Typography variant="caption">Tag</Typography>
              <Typography variant="h6">
                {/* {Prospect_details.Prospect_tags !== null
                  ? Prospect_details.Prospect_tags
                  : Prospect_details.Prospect_tags === "" && "N/A"} */}
                {Prospect_details.Prospect_tags
                  ? Prospect_details.Prospect_tags
                  : "Untagged"}
                {(localStorage.getItem("empRole") === "CTO" || localStorage.getItem("empRole") === "CEO") && <EditOutlinedIcon
                  onClick={toggleSelect}
                  style={{
                    cursor: "pointer",
                    verticalAlign: "middle",
                    width: 20,
                    height: 20,
                    marginLeft: 5,
                  }}
                />}
                {showPMsOPtions && (
                  <>
                    <div className="dropdown">
                      <div className="dropdown-content">
                        {tagData.map((item) => {
                          return (
                            <label>
                              <input
                                type="checkbox"                                
                                name={item.name}
                                id={item.name}
                                value={item.name}
                                onChange={
                                  item.name === "PIA" || item.name === "PMS"
                                    ? (e) => handlePmsRadioTag(e, item.name)
                                    : (e) => handlePmsTag(e, item.name)
                                }
                              />{" "}
                              {item.name}
                            </label>
                          );
                        })}
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginBottom: "1px" }}
                          onClick={saveSelectedTags}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </Typography>
            </div>

            {localStorage.getItem("empRole") === "MF Manager" ||
            localStorage.getItem("empRole") === "MF Executive" ||
            localStorage.getItem("empRole") === "Franchise" ? (
              ""
            ) : (
              <div>
                <Typography variant="caption">Demat</Typography>
                <Typography variant="h6">
                  {Prospect_Assigned_info.Broker
                    ? Prospect_Assigned_info.Broker
                    : "N/A"}
                </Typography>
              </div>
            )}
          </div>
        </div>
        {(localStorage.getItem("empRole") === "CTO" ||
          localStorage.getItem("empRole") === "CEO" ||
          localStorage.getItem("empRole") === "Customer Delight Executive" ||
          localStorage.getItem("empRole") === "Business Growth Executive" ||
          localStorage.getItem("empRole") === "CRT Executive" ||
          localStorage.getItem("empRole") === "CRT Manager" ||
          localStorage.getItem("empRole") ===
            "Sales and Retention Specialist" ||
          localStorage.getItem("empRole") === "Sales Manager"|| localStorage.getItem("empRole") === "MF Manager" ||
          localStorage.getItem("empRole") === "MF Executive" ||
          localStorage.getItem("empRole") === "Sales and Retention Specialist" ||
          localStorage.getItem("empRole") === "Franchise" ) && (
          <>
            <div
              style={{
                display: "flex",
                marginBottom: "30px",
              }}
            >
              <TextField
                id="outlined-basic"
                placeholder="Add a Note"
                variant="outlined"
                multiline
                fullWidth
                value={noteval}
                maxRows={4}
                onChange={handleChange}
                inputProps={{
                  maxlength: CHARACTER_LIMIT,
                }}
                helperText={`${noteval.length}/${CHARACTER_LIMIT}`}
              />
              <div>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#2835d5",
                    color: "#fff",
                    marginLeft: "10px",
                    height: "55px",
                    fontSize: "15px",
                  }}
                  onClick={handleUpdate}
                >
                  Update
                </Button>
              </div>
            </div>
          </>
        )}
        <div
          className="userinfotab"
          onClick={editProspect}
          style={{ cursor: "pointer" }}
        >
          <p style={{ fontSize: "20px" }}>User Info</p>
          <p className="arrow">
            <ArrowForwardIcon className="innerarrow" />
          </p>
        </div>

        {/* Grid 1 */}

        {localStorage.getItem("empRole") === "MF Manager" ||
        localStorage.getItem("empRole") === "MF Executive" ||
        localStorage.getItem("empRole") === "Franchise" ? (
          <>
            <Grid
              container
              style={{ marginTop: "20px" }}
              className={"prospectgrids"}
            >
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoPersonalProfile}>
                  <Typography variant="h6">Personal Profile</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoInvestmentProfile}>
                  <Typography variant="h6">Investment Profile</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoGoalsDashBoard}>
                  <Typography variant="h6">Goal Section</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoActivityLog}>
                  <Typography variant="h6">Activity Log</Typography>
                </Paper>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={3} onClick={gotoNotesReviewPage}>
                <Paper className={classes.tile}>
                  <Typography variant="h6">Notes</Typography>
                </Paper>
              </Grid>
          </>
        ) : (
          <>
            <Grid
              container
              style={{ marginTop: "20px" }}
              className={"prospectgrids"}
            >
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile}>
                  <Typography variant="h6">Subscription Manager</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoPersonalProfile}>
                  <Typography variant="h6">Personal Profile</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoInvestmentProfile}>
                  <Typography variant="h6">Investment Profile</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile}>
                  <Typography variant="h6">Requests Section</Typography>
                </Paper>
              </Grid>
            </Grid>

            {/* Grid 2 */}
            <Grid
              container
              style={{ marginTop: "20px" }}
              className={"prospectgrids"}
            >
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoGoalsDashBoard}>
                  <Typography variant="h6">Goal Section</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoReferalDashboard}>
                  <Typography variant="h6">Referral Dashboard</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoActivityLog}>
                  <Typography variant="h6">Activity Log</Typography>
                </Paper>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                onClick={gotoProspectSatisfaction}
              >
                <Paper className={classes.tile}>
                  <Typography variant="h6">Prospect Satisfaction</Typography>
                </Paper>
              </Grid>
            </Grid>

            {/* Grid 3 */}
            <Grid
              container
              style={{ marginTop: "20px" }}
              className={"prospectgrids"}
            >
              <Grid item xs={12} sm={6} md={3}>
                <Paper className={classes.tile} onClick={gotoLandingpage2}>
                  <Typography variant="h6">Landing Page 2</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3} onClick={gotoRmReassignPage}>
                <Paper className={classes.tile}>
                  <Typography variant="h6">
                    Prospect Reassigning flow
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={3} onClick={gotoNotesReviewPage}>
                <Paper className={classes.tile}>
                  <Typography variant="h6">Notes</Typography>
                </Paper>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                onClick={gotoaddPaymentLinksPage}
              >
                <Paper className={classes.tile}>
                  <Typography variant="h6">Payment Links</Typography>
                </Paper>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={3}>
            <Paper className={classes.tile} onClick={gotoReferalDashboard}>
              <Typography variant="h6">Referral Dashboard</Typography>
            </Paper>
          </Grid> */}
              {/* <Grid item xs={12} sm={6} md={3}>
            <Paper className={classes.tile} onClick={gotoActivityLog}>
              <Typography variant="h6">Activity Log</Typography>
            </Paper>
          </Grid> */}
              {/* <Grid item xs={12} sm={6} md={3} onClick={gotoProspectSatisfaction}>
            <Paper className={classes.tile}>
              <Typography variant="h6">Prospect Satisfaction</Typography>
            </Paper>
          </Grid> */}
            </Grid>
          </>
        )}

        {/* <Grid container style={{ marginTop: "30px" }} >
                <Grid item xs={12} sm={12} md={4} lg={5} xl={6}>
                    <Grid item xs={12}>
                        <Typography  variant="h6">User Questionnaire</Typography>
                    </Grid>
                    {
                        userQuestionnaire.map((obj,inx) => {
                            return (
                                <Grid container style={{ marginTop: "10px" }} key={inx+obj["value"]}>
                                    <Grid item xs={12}>
                                        <Typography  variant="caption">{obj["lable"]}</Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography  variant="h6">{(Prospect_questionnaire[obj["value"]] &&
                                            Prospect_questionnaire[obj["value"]] === true) ?
                                            "Yes" : (Prospect_questionnaire[obj["value"]]) ?
                                                Prospect_questionnaire[obj["value"]] :
                                                Prospect_questionnaire[obj["value"]] === false ? "No" :
                                                    "N/A"}</Typography>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }

                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={7} xl={6}>
                <Grid container className={'prospectgrids'}>
                    <Grid item xs={12} sm={12} md={5}  style={{ marginTop: "10%" }}>
                        <Paper className={classes.analyticwindow}>
                            <Grid container style={{ padding: "10px" }}>
                                <Grid item xs={12}>
                                    <Typography  variant="caption">Get Back Date</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="h6">
                                        {getDate(Prospect_Assigned_info["get_back_date"])}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="caption">Status</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="h6">
                                        {Prospect_Assigned_info["status"]}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="caption">
                                        Reason:
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Typography  variant="h6">
                                        {(Prospect_Assigned_info["reason"]) ? Prospect_Assigned_info["reason"] : "N/A"}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Typography  variant="caption">
                                        {getDate(Prospect_Assigned_info["leadcreated_at"])}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3} md={1} />

                    <Grid item xs={12} sm={12} md={5} style={{ marginTop: "10%" }}>
                        <Paper className={classes.analyticwindow} >
                            <Grid container style={{ padding: "10px" }} >
                                <Grid item xs={12}>
                                    <Typography  variant="h6">Call Analytics</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="caption">
                                        Calls Answered
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="h6">{call_Analytics.answered}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="caption">
                                        Calls Not Answered
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography  variant="h6">
                                        {call_Analytics.notanswered}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Typography  variant="caption">
                                        Calls Rejected
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Typography  variant="h6">
                                        {call_Analytics.rejected}
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Paper>
                    </Grid>
                </Grid>
                </Grid>
            </Grid>
            <Grid container style={{ marginTop: "30px" }} >
            <Grid item xs={12} sm={6} md={6}>
                        <Button style={friendly?{backgroundColor:"#11be74" ,color:"#ffff", paddingLeft:50,paddingRight:50,borderRadius: "10px"}:{color:"rgb(106 106 106)", paddingLeft:50,paddingRight:50,borderRadius: "10px",backgroundColor:"#dbdbdb"}}
                         endIcon={friendly||friendly===null?<ThumbUpIcon />:<ThumbDownAltIcon />} onClick={setFriendlyBtn}>{friendly||friendly===null?"Very Friendly":"Not Friendly"}</Button>
                    </Grid>
            </Grid> */}

        <Dialog
          open={open}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {Prospect_Basic_info.blocked ? "Unblock User" : "Block User"}
          </DialogTitle>
          <DialogContent>
            Are you sure to {Prospect_Basic_info.blocked ? "Unblock" : "Block"}{" "}
            {currentUser}?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              onClick={(e) => submitBlock(e)}
              variant="contained"
              color="primary"
              disabled={disableUpdateBtn}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openArchivingModal}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {/* Delete User */}
            <InputLabel
              id="emailIDLable"
              style={{ fontWeight: "bold", color: "#000" }}
            >
              Comments
            </InputLabel>
            <TextField
              id="outlined-basic"
              placeholder="Comments"
              variant="outlined"
              multiline
              fullWidth
              value={formObject.archiveComment}
              maxRows={4}
              name="assigned_comments"
              onChange={handleChangeArchiveComment}
              inputProps={{
                maxlength: archiveCommentLimit,
              }}
              helperText={
                formObject.archiveComment
                  ? `${formObject.archiveComment.length}/${archiveCommentLimit}`
                  : ""
              }
            />
          </DialogTitle>
          <DialogContent>
            Are you sure. Action once performed cannot be un-done
            {/* {myparam.cust__userID ? myparam.cust__userID : "N/A"} */}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              variant="contained"
              color="primary"
              onClick={submitArchiveProspect}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}

export default ProspectDetails;
